export default __webpack_public_path__ + "static/media/doctor-color-icon.065a0945.svg";